import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {ButtonGroup} from 'shells/button-group/button-group';

import type {ReportURLParams} from '../../../reports/report-types';

import {GraduatedFilter} from '../../entity-lists/graduated-filter';
import type {Option} from '../../entity-lists/graduated-filter';

import {getUpdatedFilters} from './helpers';

type Props = {
    editionId: string;
    filters: FilterObject[];
    urlParams: ReportURLParams<'contacts'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
};

export function SmsEditionRecipientEngagementFilter(props: Props) {
    const {editionId} = props;

    const defaultOption = React.useMemo(() => {
        return {value: {sentSmsEditions: editionId}, label: 'All recipients'};
    }, [editionId]);

    const options = React.useMemo(() => {
        return [
            defaultOption,
            {value: {optedOutSmsEditions: editionId}, label: 'Opted out'},
            {value: {bouncedSmsEditions: editionId}, label: 'Undelivered'},
            {value: {repliedSmsEditions: editionId}, label: 'Replied'},
        ];
    }, [editionId, defaultOption]);

    const optionKeys = React.useMemo(() => {
        return options.map((option) => {
            return Object.keys(option.value)[0];
        });
    }, [options]);

    const activeFilterKey = props.filters
        .map((filterObj) => {
            return Object.keys(filterObj)[0];
        })
        .find((filterKey) => {
            return filterKey !== 'sentSmsEditions' && optionKeys.includes(filterKey);
        });

    return (
        <ButtonGroup>
            <GraduatedFilter
                {...props}
                getNewFilters={(option: Option) => getUpdatedFilters(option, props.filters)}
                activeFilterKey={activeFilterKey}
                defaultOption={defaultOption}
                options={options}
            />
        </ButtonGroup>
    );
}
